import { render, staticRenderFns } from "./TrainingOptions.vue?vue&type=template&id=23dcfbf2"
import script from "./TrainingOptions.vue?vue&type=script&lang=js"
export * from "./TrainingOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports